import { type ReactNode } from 'react'

import { formatFullNumber } from '@/utils/formatUtil'

import styles from './OptionCount.module.scss'

type Props = {
  children?: ReactNode
  count: number
}

export const OptionCount = ({ children, count }: Props) => (
  <span className={styles.container}>
    <span>{formatFullNumber(count)}</span>
    {children && <span>{children}</span>}
  </span>
)
